import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    filterSelected: {
      background: `${theme.palette.primary.dark} !important`,
      color: theme.palette.primary.contrastText,
    },
  });
});
